import type {AccountApiModel} from '../../../api/account';
import type {ApiListResponse} from '../../../api/types';

import {accountStore} from '../../../api/account';
import {apiRequest} from '../../../api/utils/apiRequest';
import {alert} from '../../../components/alert';
import {askToFillPrivateProfileIfNeeded} from '../../sync-private-profile';
import {COMMAND} from '../utils';

export const accountDelete = async (account: AccountApiModel) => {
  if (!(await alert.confirm())) {
    return COMMAND.CANCEL;
  }

  await accountStore.delete(account);

  const {_items: accounts}: ApiListResponse<AccountApiModel> = await apiRequest(
    {
      method: 'user.accounts.list',
    },
  );

  const accountsByType = accounts.filter(item => item.type === account.type);

  if (accountsByType.length === 1) {
    askToFillPrivateProfileIfNeeded({
      [accountsByType[0]!.type]: accountsByType[0]!.value,
    });
  }
};
